import { useNavigate } from 'react-router-dom';
import styles from './Resolucoes.module.scss';

interface LinkItem {
  readonly label: string;
  readonly href: string;
}

const resolucoes: LinkItem[] = [
  {
    label: 'Resolução ANM nº 156, 8 de Abril de 2024',
    href: 'https://anmlegis.datalegis.net/action/ActionDatalegis.php?acao=abrirTextoAto&link=S&tipo=RES&numeroAto=00000156&seqAto=000&valorAno=2024&orgao=DC/ANM/MME&cod_modulo=566&cod_menu=8303',
  },
  {
    label: 'Resolução ANM nº 200, 27 de Março de 2025',
    href: 'https://anmlegis.datalegis.net/action/ActionDatalegis.php?acao=abrirTextoAto&link=S&tipo=RES&numeroAto=00000200&seqAto=000&valorAno=2025&orgao=DC/ANM/MME&codTipo=&desItem=&desItemFim=&cod_modulo=566&cod_menu=8303',
  },
  {
    label: 'Resolução ANM nº 241, 30 de Junho de 2026',
    href: 'https://anmlegis.datalegis.net/action/ActionDatalegis.php?acao=abrirTextoAto&link=S&tipo=RES&numeroAto=00000241&seqAto=000&valorAno=2026&orgao=DC/ANM/MME&cod_modulo=351&cod_menu=8731',
  },
];

function Resolucoes() {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <button
        className={styles.back}
        onClick={() => navigate('/')}
        type='button'
      >
        <i className='fas fa-arrow-left' aria-hidden='true' /> Voltar
      </button>

      <section className={styles.section}>
        <div className={styles.sectionHeader}>
          <div className={styles.iconWrap}>
            <i className='fas fa-file-contract' aria-hidden='true' />
          </div>
          <div>
            <h2 className={styles.sectionTitle}>Resoluções</h2>
            <p className={styles.sectionSub}>
              Atos normativos da Agência Nacional de Mineração
            </p>
          </div>
        </div>
        <ul className={styles.list}>
          {resolucoes.map((item) => (
            <li key={item.href} className={styles.listItem}>
              <a
                href={item.href}
                target='_blank'
                rel='noopener noreferrer'
                className={styles.link}
              >
                <span>{item.label}</span>
                <i
                  className={`fas fa-external-link-alt ${styles.externalIcon}`}
                  aria-hidden='true'
                />
              </a>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default Resolucoes;
